import Vue from "vue";
import App from "./App.vue";
import Router from "vue-router";
import router from "./router";
import store from "./store";
import axios from "./interceptor";
import VueAxios from "vue-axios";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import "vuetify/dist/vuetify.min.css";

Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

Vue.use(Router);
Vue.use(VueAxios, axios);
Vue.use(Vuelidate);
Vue.use(VueMoment, {
  moment,
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
